var map = {
	"./applemusic.svg": "FckN",
	"./bilibili.png": "krIN",
	"./chaoxing.png": "UvJi",
	"./ckt.svg": "I7px",
	"./cnki.png": "PeC2",
	"./coding.png": "mTEC",
	"./coursera.svg": "nstP",
	"./douyu.svg": "xmsi",
	"./gitee.svg": "b17y",
	"./github.svg": "yW62",
	"./huawei.svg": "ELIl",
	"./ityxb.png": "Pc3T",
	"./jwxt.png": "Y4i6",
	"./lcu.svg": "efap",
	"./maka.png": "jMbn",
	"./mikecrm.png": "FTn0",
	"./mooc.png": "HYOl",
	"./neteasemusic.svg": "8WDs",
	"./pigai.png": "Nhoa",
	"./telegram.svg": "TY2b",
	"./tsg.gif": "Kz9z",
	"./twitter.svg": "xKzo",
	"./txdoc.png": "sbIs",
	"./txy.svg": "WQ4D",
	"./unipus.png": "dSik",
	"./uplus.png": "LHn/",
	"./xuetang.png": "Mtnk",
	"./xyw.svg": "CU15",
	"./yooc.png": "rYi6",
	"./youdao.png": "hKR7",
	"./youxy.png": "G8vD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "elfU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content ^\.\/.*$
// module id = elfU
// module chunks = 1